var map = {
	"./pmcariacica/icons/favicon/favicon.png": 258,
	"./pmci/icons/favicon/favicon.png": 4942,
	"./pmvv/icons/favicon/favicon.png": 4055,
	"./upcities/icons/favicon/favicon.png": 139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5403;